import React, { useState } from 'react'

import '../peyk.scss'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { Link } from 'react-router-dom'
import moment from 'jalali-moment'

import peykLogo from '../../../assets/svg/PeykLogo.png'
import loadingPic from '../../../assets/svg/Loading.svg'

import { DatePicker } from "zaman"
import { post } from '../../../services/https'

export default function Index() {
  const [name, setName] = useState('')
  const [meliCode, setMeliCode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [birthday, setBirthday] = useState('')
  const [education, setEducation] = useState('')
  const [motorCertificate, setMotorCertificate] = useState(true)
  const [motorInsurance, setMotorInsurance] = useState(true)
  const [alertName, setAlertName] = useState(false)
  const [alertMeliCode, setAlertMeliCode] = useState(false)
  const [alertPphoneNumber, setAlertPhoneNumber] = useState(false)
  const [alertBirthday, setAlertBirthday] = useState(false)
  const [alertEducation, setAlertEducation] = useState(false)

  const signUpHandler = (e) => {
    if (name.length > 5) {
      setAlertName(false)
    } else {
      setAlertName(true)
    }

    if (meliCode.length > 9) {
      setAlertMeliCode(false)
    } else {
      setAlertMeliCode(true)
    }

    if (phoneNumber.length >= 10) {
      setAlertPhoneNumber(false)
    } else {
      setAlertPhoneNumber(true)
    }

    if (birthday.length >= 4) {
      setAlertBirthday(false)
    } else {
      setAlertBirthday(true)
    }

    if (education.length >= 4) {
      setAlertEducation(false)
    } else {
      setAlertEducation(true)
    }

    if (name.length > 5 && meliCode.length > 9 && phoneNumber.length >= 10 && birthday.length >= 4 && education.length >= 4) {
      setLoading(true)
      post('/api/front/peyks/create', {
        name: name,
        meliCode: meliCode,
        phoneNumber: phoneNumber,
        birthday: birthday,
        education: education,
        motorCertificate: motorCertificate,
        motorInsurance:motorInsurance 
      }, {
        'Content-Type': 'application/json'
      }).then(response => {
        if (response.data.messageFa === 'پیک جدید با موفقیت ساخته شد') {
          notify('success', 'ثبت نام با موفقیت انجام شد')
          notify('success', 'به زودی با شما تماس گرفته خواهد شد')
        }
      }).catch(error => {
        setLoading(false)
        console.log()
        if (error.response.data.data.code === 11000) {
          notify('error', 'شما قبلا ثبت نام کرده اید')
        } else {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        }
      })
    }
  }

  const [loading, setLoading] = useState(false)

  return (
    <div id='peyk'>
      <ToastContainer rtl />
      <main className="countainer">
        <section className='Logo'>
          <img src={peykLogo} alt="peykLogo" />
        </section>
        <section className='from'>
          <div className="form__item">
            <label htmlFor="">نام و نام خانوادگی :</label>
            <input onChange={e => setName(e.target.value)} type="text" placeholder='امیر ...' />
            <small style={alertName ? {} : { display: 'none' }}>نام و نام خانوادگی صحیح نیست</small>
          </div>
          <div className="form__item">
            <label htmlFor="">کدملی :</label>
            <input onChange={e => setMeliCode(e.target.value)} type="number" className='form__input--ltr' placeholder='556 ...' />
            <small style={alertMeliCode ? {} : { display: 'none' }}>کدملی صحیح نیست</small>
          </div>
          <div className="form__item">
            <label htmlFor="">شماره موبایل :</label>
            <input onChange={e => setPhoneNumber(e.target.value)} type="number" className='form__input--ltr' placeholder='09 ...' />
            <small style={alertPphoneNumber ? {} : { display: 'none' }}>شماره موبایل صحیح نیست</small>
          </div>
          <div className="form__item">
            <label htmlFor="">تاریخ تولد :</label>
            <DatePicker onChange={(e) => setBirthday(moment(e.value).locale('fa').format('YYYY/MM/  DD'))} />
            <small style={alertBirthday ? {} : { display: 'none' }}>تاریخ تولد صحیح نیست</small>
          </div>
          <div className="form__item">
            <label htmlFor="">تحصیلات :</label>
            <select onChange={e => setEducation(e.target.value)} name="" id="">
              <option value="">انتخاب کنید</option>
              <option value="سیکل">سیکل</option>
              <option value="دیپلم">دیپلم</option>
              <option value="کاردانی">کاردانی</option>
              <option value="کارشناسی">کارشناسی</option>
              <option value="کارشناسی ارشد">کارشناسی ارشد</option>
            </select>
            <small style={alertEducation ? {} : { display: 'none' }}>تحصیلات صحیح نیست</small>
          </div>
          <div className="form__item--twice">
            <div>
              <label htmlFor="">گواهینامه :</label>
              <select onChange={e => setMotorCertificate(e.target.value)} name="" id="">
                <option value="true">دارم</option>
                <option value="false">ندارم</option>
              </select>
            </div>
            <div>
              <label htmlFor="">بیمه موتور :</label>
              <select onChange={e => setMotorInsurance(e.target.value)} name="" id="">
                <option value="true">دارم</option>
                <option value="false">ندارم</option>
              </select>
            </div>
          </div>
          <div className="from__button">
            <button onClick={signUpHandler} style={loading ? {display: 'none'} : {}}>
              <span style={loading ? {display: 'none'} : {}}>ثبت</span>
              <img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' />
            </button>
          </div>
        </section>
        <section className='copyright--signUp'>
          قدرت گرفته از <Link to='https://ibills.ir'>Ibills</Link> ، توسعه توسط <Link to='https://ham-team.ir'>هم‌تیم</Link>
        </section>
      </main>
    </div>
  )
}
